import React from 'react'
import './work-card.css'

const WorkCard = ({work, index}) => {
    return (
        index%2 === 0 ? (
            <div className="work-card" data-aos="fade-right">
            <img src={work.companyLogo} alt={work.company} className="work-logo" />
            <div className="work-info">
                <label className="company-name">{work.company}</label>
                <div className="work-dates">
                    <label>{work.dateJoining}</label> - <label>{work.dateEnd}</label>
                </div>
                <div className="work-desc">
                    <p>{work.work}</p>
                </div>
            </div>
            <span className="circle"></span>
        </div>
        ):(
            <div className="work-card" data-aos="fade-left">
            <img src={work.companyLogo} alt={work.company} className="work-logo" />
            <div className="work-info">
                <label className="company-name">{work.company}</label>
                <div className="work-dates">
                    <label>{work.dateJoining}</label> - <label>{work.dateEnd}</label>
                </div>
                <div className="work-desc">
                    <p>{work.work}</p>
                </div>
            </div>
            <span className="circle"></span>
        </div>
        )
    )
}

export default WorkCard
